import { FERIADOS_COLOMBIA } from 'src/app/shared';
import { Url } from '../assets/config/config';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: Url.local,
  EncryptKey: Url.EncryptKey,
  EncryptIV:Url.EncryptIV,
  encryption:Url.encryption,
  FERIADOS_COLOMBIA:Url.FERIADOS_COLOMBIA

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

